'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/4/16.
                    */


var _react = require('react');

var _reactFullpage = require('react-fullpage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoeasySectionsContainer = (_temp = _class = function (_SectionsContainer) {
  (0, _inherits3.default)(GoeasySectionsContainer, _SectionsContainer);

  function GoeasySectionsContainer() {
    (0, _classCallCheck3.default)(this, GoeasySectionsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GoeasySectionsContainer).apply(this, arguments));
  }

  (0, _createClass3.default)(GoeasySectionsContainer, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (this.state.activeSection !== nextState.activeSection) {
        this.props.activeChange(nextState.activeSection);
      }
    }
  }]);
  return GoeasySectionsContainer;
}(_reactFullpage.SectionsContainer), _class.propTypes = {
  activeChange: _react.PropTypes.func
}, _temp);
exports.default = GoeasySectionsContainer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasySectionsContainer/GoeasySectionsContainer.js
 ** module id = 1347
 ** module chunks = 0
 **/